// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vTjL","left":"styles_left__3BfhA"};